// import moment from '@/plugins/moment';
import { toCamelCaseProperties } from '@fixit/utils';

export default class FavoriteTreatment {
	constructor(args) {
		args = toCamelCaseProperties(args) || {};
		this.userFavoriteTreatmentId = args.userFavoriteTreatmentId || 0
		this.treatmentId = args.treatmentId || ''
		this.urlSafe = args.urlSafe || ''
		this.treatmentName = args.treatmentName || ''
		this.urlSafeTreatmentName = args.urlSafeTreatmentName || ''
		this.siteName = args.siteName || ''
		this.siteId = args.siteId || null
		this.ftcCategoryImgUrls = args.ftcCategoryImgUrls || []
		this.ftcCategoryImgUrlsThumbnails = args.ftcCategoryImgUrlsThumbnails || []
		this.useTreatmentImages = args.useTreatmentImages || false
		this.isBundle = args.isBundle || false
		this.siteNameUrlSafe = args.siteNameUrlSafe || null
	}

	assign(treatment) {
		Object.assign(this, toCamelCaseProperties(treatment));
	}
}
